import {
	deviationLabels,
	MilkingProcessDeviationType,
} from 'models/MilkingProcess'
import { useMemo } from 'react'

export const useDeviationTypesFilter = () => {
	const deviationTypesForFilter = useMemo(() => {
		return Object.entries(deviationLabels).map(([type, label]) => ({
			type: type as MilkingProcessDeviationType,
			value: label,
		}))
	}, [])

	return {
		deviationTypesForFilter,
	}
}
